import * as React from 'react';
import { useState } from 'react';

import { Button, Divider, Grid, Stack, Title } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { StaffAvailability } from 'types';
import { DAY_OF_WEEK_TITLE_MAP, DAY_OF_WEEK_VALUES, DayOfWeekEnum } from 'types/enums';

import CreateStaffAvailabilityModal from './CreateStaffAvailabilityModal';
import WeekDayStaffAvailabilityList from './WeekDayStaffAvailabilityList';

dayjs.extend(customParseFormat);

interface WeeklyScheduleVIewFormProps {
  isEditable: boolean;
  data: StaffAvailability[];
}

const WeeklyScheduleForm = ({ isEditable, data }: WeeklyScheduleVIewFormProps): JSX.Element => {
  const [isCreateModalOpened, { close: closeCreateModal, open: openCreateModal }] = useDisclosure(false);
  const [dayOfWeekAvailabilityToCreate, setDayOfWeekAvailabilityToCreate] = useState<null | DayOfWeekEnum>(
    null,
  );

  const handleOpenCreateModal = (dow: DayOfWeekEnum): void => {
    openCreateModal();
    setDayOfWeekAvailabilityToCreate(dow);
  };
  const handleCloseCreateModal = (): void => {
    closeCreateModal();
    setDayOfWeekAvailabilityToCreate(null);
  };

  return (
    <Stack m='xl' p='xl' spacing='xl'>
      {DAY_OF_WEEK_VALUES.map(dayOfWeek => {
        const dayOfWeekTitle = DAY_OF_WEEK_TITLE_MAP[dayOfWeek as DayOfWeekEnum];

        return (
          <React.Fragment key={dayOfWeek}>
            <Divider />
            <Grid columns={6} p={0} align='center'>
              <Grid.Col span={1} p='sm'>
                <Title order={4}>{dayOfWeekTitle}</Title>
              </Grid.Col>
              <Grid.Col
                span={5}
                p={0}
                sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}
              >
                <WeekDayStaffAvailabilityList dayOfWeek={dayOfWeek} data={data} isEditable={isEditable} />
                {isEditable && (
                  <Button ml='md' onClick={() => handleOpenCreateModal(dayOfWeek)}>
                    Add time
                  </Button>
                )}
              </Grid.Col>
              {/*<Grid.Col span={1}></Grid.Col>*/}
            </Grid>
          </React.Fragment>
        );
      })}

      <CreateStaffAvailabilityModal
        key={dayOfWeekAvailabilityToCreate}
        opened={isCreateModalOpened && !!dayOfWeekAvailabilityToCreate}
        handleClose={handleCloseCreateModal}
        dayOfWeek={dayOfWeekAvailabilityToCreate as DayOfWeekEnum}
      />
    </Stack>
  );
};

export default WeeklyScheduleForm;
